export const APP_ERROR_LOG_MAX_ITEMS = 100;

export type AppErrorLogItem = {
  id: string;
  at: number;
  message: string;
};

export function normalizeErrorMessage(message: string): string {
  const t = String(message).trim();
  return t || 'Неизвестная ошибка';
}

/**
 * Добавляет запись и обрезает буфер с начала при превышении лимита.
 */
export function appendErrorItem(
  items: AppErrorLogItem[],
  entry: AppErrorLogItem,
  maxItems: number = APP_ERROR_LOG_MAX_ITEMS
): AppErrorLogItem[] {
  const next = [...items, entry];
  if (next.length <= maxItems) {
    return next;
  }
  return next.slice(next.length - maxItems);
}

export function formatErrorLogForCopy(items: AppErrorLogItem[]): string {
  return items
    .map((it, i) => {
      const time = new Date(it.at).toLocaleString();
      return `${i + 1}. [${time}]\n${it.message}`;
    })
    .join('\n\n');
}

export function truncateForSnackbar(text: string, maxLen: number): string {
  if (text.length <= maxLen) {
    return text;
  }
  return `${text.slice(0, maxLen - 1)}…`;
}
